export const JSON_CONTENT_TYPE = 'application/json';
export const CONTENT_TYPE_HEADER = 'Content-Type';
export const REQUEST_TYPES_WITH_BODY = ['post', 'put', 'patch'];
export const CLIENT_ID_HEADER = 'x-client-id';
export const CORRELATION_ID_HEADER = 'x-correlation-id';
export const STATSIG_HEADER = 'X-Statsig-Ab-Params';
export const STATSIG_COOKIE_PREFIX = 'statsig_';
export const allowedKeysForTolkien = 'dgr_';
export const hbAdultCookieKey = 'hb_adult';
export const COUNTRY_CODE_COOKIE_NAME = 'hbCountryCode'
export const COOKIE_KEY = 'Cookie';
export const XKEY = 'xkey';
export const LINK = 'Link';
export const YKEY = 'ykey';
export const COLLECTION_PAGE_REDIRECTION = 'x-collection-redirection';
export const X_VARNISH_CACHE_CONTROL_KEY = 'x-varnish-cache-control'
